import { urls } from './urls';

export const v1 = {
  urls,
};
